export var PlanStructureChange;
(function (PlanStructureChange) {
    let data_type;
    (function (data_type) {
        data_type["PLAN_STRUCTURE"] = "plan_structure";
    })(data_type = PlanStructureChange.data_type || (PlanStructureChange.data_type = {}));
})(PlanStructureChange || (PlanStructureChange = {}));
